import { IconProps } from './types';

export const StarIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.173 17.803'>
    <path
      // eslint-disable-next-line max-len
      d='M20.695,9.538H14.4L12.487,3.829a.693.693,0,0,0-1.3,0L9.273,9.538H2.935a.687.687,0,0,0-.685.685.5.5,0,0,0,.013.116.658.658,0,0,0,.287.484l5.174,3.646L5.738,20.241a.687.687,0,0,0,.235.77.662.662,0,0,0,.385.167.839.839,0,0,0,.428-.154l5.05-3.6,5.05,3.6a.8.8,0,0,0,.428.154.615.615,0,0,0,.381-.167.678.678,0,0,0,.235-.77l-1.986-5.773,5.131-3.68.124-.107a.718.718,0,0,0,.223-.458A.725.725,0,0,0,20.695,9.538Z'
      transform='translate(-2.25 -3.375)'
      fill='#fff'
      {...props}
    />
  </svg>
);
